export enum ElementIds {
  MessageComposerTextArea = 'messageComposerTextArea',
}
